import { Store } from 'vuex'
import tabbarStore from './modules/tabbarStore'
import cartStore from './modules/cartStore'
import userStore from './modules/userStore'
import pageStore from './modules/pageStore'
import screenStore from './modules/screenStore'
import uiStore from './modules/uiStore'


const store = new Store({
    modules: {
        tabbarStore,
        cartStore,
        userStore,
        uiStore,
        pageStore,
        screenStore
    },
    state: {
    },
    mutations: {
    }
})


export default store
